import React from 'react';
import DxDataGrid, {
  Column,
  IColumnProps,
  IDataGridOptions,
} from 'devextreme-react/data-grid';
import './DataGrid.scss';

interface DataGridOptionsWithFields extends IDataGridOptions {
  fields: IColumnProps[];
  title: string;
}

export const DataGrid: React.FC<DataGridOptionsWithFields> = ({
  fields,
  title,
  ...rest
}) => (
  <div className="datagrid-wrapper">
    <p>{title}</p>
    <DxDataGrid {...rest} defaultSelectedRowKeys>
      {fields.map((field) => (
        <Column key={`${field.caption}-${field.dataField}`} {...field} />
      ))}
    </DxDataGrid>
  </div>
);
